import { useMemo } from 'react'
import _ from 'lodash'
import { useFlags } from 'launchdarkly-react-client-sdk'

import { useConfigStateValue } from 'contexts'

import type { FeatureFlag } from 'types/common'

export const initialEnabledFeatureFlagState = {
  rulesEngine: true,
  tileLayer: false,
  issue: true,
  site: false,
  asset: false,
  workflowGeofenceAncillaryData: false,
  dynamicScheduling: false,
  jsonForm: true,
  createUser: true,
  ldarSimFileUploader: false,
  jsonFormListBuilder: false,
  siteDeepDive: false,
  loginRedirectMethane: false,
}

const useFeatureFlag = (): FeatureFlag => {
  const { featureFlags } = useConfigStateValue() || {}

  const ldFlags = useFlags()

  return useMemo(() => {
    return _.defaults(
      {},
      _.merge({}, ldFlags, featureFlags),
      initialEnabledFeatureFlagState
    )
  }, [featureFlags, ldFlags])
}

export default useFeatureFlag
